/* Mobile "All Filters" drawer for the collection page.
   Filtering itself still runs through the theme's existing AJAX form (theme.js);
   this only handles opening/closing the off-canvas panel. Uses event delegation
   so it keeps working after theme.js swaps [data-filters]'s innerHTML on every
   filter change. */
(function () {
  var activeTrigger = null;

  function getFiltersRoot() {
    return document.querySelector('[data-filters]');
  }

  /* Every group should read as permanently open in the drawer - set the real
     "open" attribute (not just a CSS height override) so the theme's own
     "dim the closed groups" rule (details:not([open])) never has anything to
     dim, and so it survives whatever the accordion JS does on click. */
  function expandAllAccordions(root) {
    root.querySelectorAll('[data-accordion]').forEach(function (accordion) {
      accordion.setAttribute('open', 'true');
      var body = accordion.querySelector('[data-accordion-body]');
      if (body) body.style.height = 'auto';
    });
  }

  function openDrawer(trigger) {
    var root = getFiltersRoot();
    if (!root) return;

    activeTrigger = trigger || null;
    root.classList.add('is-open');
    expandAllAccordions(root);
    document.documentElement.classList.add('filters-scroll-lock');

    var panel = root.querySelector('[data-filters-panel]');

    if (window.theme && window.theme.a11y) {
      window.theme.a11y.trapFocus(panel || root, {
        elementToFocus: root.querySelector('[data-filters-close]'),
      });
    }
  }

  function closeDrawer() {
    var root = getFiltersRoot();
    if (!root || !root.classList.contains('is-open')) return;

    root.classList.remove('is-open');
    document.documentElement.classList.remove('filters-scroll-lock');

    if (window.theme && window.theme.a11y) {
      window.theme.a11y.removeTrapFocus();
    }

    if (activeTrigger) {
      activeTrigger.focus();
      activeTrigger = null;
    }
  }

  // Filtering re-fetches and swaps [data-filters]'s innerHTML, which recreates
  // every <details> without the forced-open attribute - re-apply it while the
  // drawer is open so a live filter change can't bring a closed group back.
  var observerRoot = getFiltersRoot();
  if (observerRoot && window.MutationObserver) {
    new MutationObserver(function () {
      if (observerRoot.classList.contains('is-open')) {
        expandAllAccordions(observerRoot);
      }
    }).observe(observerRoot, {childList: true});
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-filters-toggle]');
    if (toggle) {
      event.preventDefault();
      openDrawer(toggle);
      return;
    }

    var dismiss = event.target.closest('[data-filters-close], [data-filters-apply]');
    if (dismiss) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (event.target.hasAttribute('data-filters-backdrop')) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.code === 'Escape') {
      closeDrawer();
    }
  });

  document.addEventListener('theme:resize', function () {
    if (window.innerWidth >= 1366) {
      closeDrawer();
    }
  });
})();
